module.exports = __webpack_public_path__ + "static/media/nepza-certificate.801dfe35.png";